import { APICore } from "./apiCore";

const api = new APICore();

function getData() {
  const baseUrl = `/web/user-referals`;
  return api.get(`${baseUrl}`, {});
}

export { getData };
